import { ActionReducer, Action } from '@ngrx/store';
import { UserInitState } from '../models/user-reducer.interface';

export const UPDATE_TOKEN = 'UPDATE_TOKEN';
export const UPDATE_SET_USER_PASSWORD_TOKEN = 'UPDATE_SET_USER_PASSWORD_TOKEN';
export const UPDATE_USER_LOGGED_IN = 'UPDATE_USER_LOGGED_IN';
export const UPDATE_USER_HAS_PASSWORD = 'UPDATE_USER_HAS_PASSWORD';
export const UPDATE_USER_HAS_ACCOUNT_DETAILS = 'UPDATE_USER_HAS_ACCOUNT_DETAILS';
export const UPDATE_USER_SHOW_TOAST = 'UPDATE_USER_SHOW_TOAST';
export const UPDATE_USER_EMAIL_TOKEN = 'UPDATE_USER_EMAIL_TOKEN';
export const UPDATE_USER_EMAIL_TOKEN_VALID = 'UPDATE_USER_EMAIL_TOKEN_VALID';
export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_USER_EMAIL = 'UPDATE_USER_EMAIL';
export const UPDATE_USER_ROLE = 'UPDATE_USER_ROLE';
export const UPDATE_USER_ADDRESSES = 'UPDATE_USER_ADDRESSES';
export const UPDATE_USER_PERMISSIONS = 'UPDATE_USER_PERMISSIONS';
export const UPDATE_USER_STATUS = 'UPDATE_USER_STATUS';
export const UPDATE_TOKEN_VALID = 'UPDATE_TOKEN_VALID';
export const UPDATE_REDIRECT = 'UPDATE_REDIRECT';
export const UPDATE_ADMIN_USERS = 'UPDATE_ADMIN_USERS';
export const UPDATE_AMEND_CARDS = 'UPDATE_AMEND_CARDS';
export const UPDATE_NEW_USER = 'UPDATE_NEW_USER';
export const UPDATE_MARKETING_ENROLMENT = 'UPDATE_MARKETING_ENROLMENT';
export const UPDATE_SURVEY_MARKETING_ENROLMENT = 'UPDATE_SURVEY_MARKETING_ENROLMENT';
export const UPDATE_SMS_WHATSAPP_ENROLMENT = 'UPDATE_SMS_WHATSAPP_ENROLMENT';
export const UPDATE_SURVEY_SMS_WHATSAPP_ENROLMENT = 'UPDATE_SURVEY_SMS_WHATSAPP_ENROLMENT';
export const UPDATE_2FA_AUTH = 'UPDATE_2FA_AUTH';
export const REFRESH_USER_STATE = 'REFRESH_USER_STATE';
export const RESET_USER_STATE = 'RESET_USER_STATE';

export interface ActionWithPayloadInterface extends Action {
  payload: any;
}

const initState: UserInitState = {
  userDetails: {
    currentUser: {},
    userToken: '',
    setPasswordUserToken: '',
    userTokenValid: false,
    userLoggedIn: false,
    userShowToast: false,
    userHasPassword: false,
    userOTPVerified: false,
    userEmailToken: {},
    userEmailTokenValid: true,
    userHasAccountDetails: false,
    userEmail: '',
    userRole: '',
    userAddresses: [],
    userPermissions: {
      showAdminFeatures: false
    },
    userStatus: 0,
    redirect: { path: '', ref: ''},
    adminUsers: {
      listOfUsers: null
    },
    amendUserCards: null,
    newUser: null,
    hasMarketingEnrolment: true,
    hasSurveyMarketingEnrolment: false,
    hasSmsWhatsAppEnrolment: true,
    hasSurveySmsWhatsAppEnrolment: false,
    is2FARequired: false
  }
};

export function userReducer (state: UserInitState = initState, action: ActionWithPayloadInterface) {

  switch (action.type) {
    case UPDATE_USER:
      return Object.assign({}, state, { userDetails: Object.assign({}, state.userDetails, { currentUser: action.payload })});

    case UPDATE_SET_USER_PASSWORD_TOKEN:
      return Object.assign({}, state, { userDetails: Object.assign({}, state.userDetails, { setPasswordUserToken: action.payload })});

    case UPDATE_TOKEN:
      return Object.assign({}, state, { userDetails: Object.assign({}, state.userDetails, { userToken: action.payload })});

    case UPDATE_TOKEN_VALID:
      return Object.assign({}, state, { userDetails: Object.assign({}, state.userDetails, { userTokenValid: action.payload })});

    case UPDATE_USER_LOGGED_IN:
      return Object.assign({}, state, { userDetails: Object.assign({}, state.userDetails, { userLoggedIn: action.payload })});

    case UPDATE_USER_SHOW_TOAST:
      return Object.assign({}, state, { userDetails: Object.assign({}, state.userDetails, { userShowToast: action.payload })});

    case UPDATE_USER_HAS_PASSWORD:
      return Object.assign({}, state, { userDetails: Object.assign({}, state.userDetails, { userHasPassword: action.payload })});

    case UPDATE_USER_HAS_ACCOUNT_DETAILS:
      return Object.assign({}, state, { userDetails: Object.assign({}, state.userDetails, { userHasAccountDetails: action.payload })});

    case UPDATE_USER_EMAIL_TOKEN:
      return Object.assign({}, state, { userDetails: Object.assign({}, state.userDetails, { userEmailToken: action.payload })});

    case UPDATE_USER_EMAIL_TOKEN_VALID:
      return Object.assign({}, state, { userDetails: Object.assign({}, state.userDetails, { userEmailTokenValid: action.payload })});

    case UPDATE_USER_EMAIL:
      return Object.assign({}, state, { userDetails: Object.assign({}, state.userDetails, { userEmail: action.payload })});

    case UPDATE_USER_ROLE:
      return Object.assign({}, state, { userDetails: Object.assign({}, state.userDetails, { userRole: action.payload })});

    case UPDATE_USER_ADDRESSES:
      return Object.assign({}, state, { userDetails: Object.assign({}, state.userDetails, { userAddresses: action.payload })});

    case UPDATE_USER_PERMISSIONS:
      return Object.assign({}, state, { userDetails: Object.assign({}, state.userDetails, { userPermissions: action.payload })});

    case UPDATE_USER_STATUS:
      return Object.assign({}, state, { userDetails: Object.assign({}, state.userDetails, { userStatus: action.payload })});

    case UPDATE_REDIRECT:
      return Object.assign({}, state, { userDetails: Object.assign({}, state.userDetails, { redirect: action.payload })});

    case UPDATE_ADMIN_USERS:
      return Object.assign({}, state, { userDetails: Object.assign({}, state.userDetails, { adminUsers: action.payload })});

    case UPDATE_AMEND_CARDS:
      return Object.assign({}, state, { userDetails: Object.assign({}, state.userDetails, { amendUserCards: action.payload })});

    case UPDATE_NEW_USER:
      return Object.assign({}, state, { userDetails: Object.assign({}, state.userDetails, { newUser: action.payload })});

    case UPDATE_MARKETING_ENROLMENT:
      return Object.assign({}, state, { userDetails: Object.assign({}, state.userDetails, { hasMarketingEnrolment: action.payload })});

    case UPDATE_SURVEY_MARKETING_ENROLMENT:
      return Object.assign({}, state, { userDetails: Object.assign({}, state.userDetails, { hasSurveyMarketingEnrolment: action.payload })});

    case UPDATE_SMS_WHATSAPP_ENROLMENT:
      return Object.assign({}, state, { userDetails: Object.assign({}, state.userDetails, { hasSmsWhatsAppEnrolment: action.payload })});

    case UPDATE_SURVEY_SMS_WHATSAPP_ENROLMENT:
      return Object.assign({}, state, { userDetails: Object.assign({}, state.userDetails, { hasSurveySmsWhatsAppEnrolment: action.payload })});

    case UPDATE_2FA_AUTH:
      return Object.assign({}, state, { userDetails: Object.assign({}, state.userDetails, { is2FARequired: action.payload })});

    case REFRESH_USER_STATE:
      return refreshUser(state, action.payload);
      // return Object.assign({}, state, { userDetails: Object.assign({}, state.userDetails, { redirect: action.payload })});

    case RESET_USER_STATE:
      state = Object.assign({}, initState);
      return state;

    default:
      return state;
  }

};

export function refreshUser(state: any, refreshObj: any) {
  return{
    userDetails: {
      currentUser: state.userDetails.currentUser,
      userToken: refreshObj.userDetails.userToken,
      setPasswordUserToken: refreshObj.userDetails.userToken,
      userTokenValid: refreshObj.userDetails.userTokenValid,
      userLoggedIn: refreshObj.userDetails.userLoggedIn,
      userShowToast: refreshObj.userDetails.userShowToast,
      userEmailToken: refreshObj.userDetails.userEmailToken,
      userEmailTokenValid: refreshObj.userDetails.userEmailTokenValid,
      userHasPassword: refreshObj.userDetails.userHasPassword,
      userEmail: refreshObj.userDetails.userEmail,
      userRole: refreshObj.userDetails.userRole,
      userAddresses: refreshObj.userDetails.userAddresses,
      userPermissions: refreshObj.userDetails.userPermissions,
      userStatus: refreshObj.userDetails.userStatus,
      redirect: refreshObj.userDetails.redirect,
      adminUsers: refreshObj.userDetails.adminUsers,
      amendUserCards: refreshObj.userDetails.amendUserCards,
      newUser: refreshObj.userDetails.newUser,
      hasMarketingEnrolment: refreshObj.userDetails.hasMarketingEnrolment,
      is2FARequired: refreshObj.userDetails.is2FARequired
    }
  };
}
